export enum SubscriptionPriceEnum {
    // Renting Contract Documents
    Start_Monthly = 'start_subscription_monthly',
    Smart_Monthly = 'smart_subscription_monthly',
    Scale_Monthly = 'scale_subscription_monthly',
    Start_Yearly = 'start_subscription_yearly',
    Smart_Yearly = 'smart_subscription_yearly',
    Scale_Yearly = 'scale_subscription_yearly'
}

export interface SubscriptionPriceDetails {
    subscriptionPrice: number;
    subscriptionCurrency: string;
    subscriptionUniqueName: string;
}

export const SUBSCRIPTION_PRICES: Record<SubscriptionPriceEnum, SubscriptionPriceDetails> = {
    [SubscriptionPriceEnum.Start_Monthly]: {
        subscriptionPrice: 14.99,
        subscriptionCurrency: 'RON',
        subscriptionUniqueName: 'start_subscription_monthly',
    },
    [SubscriptionPriceEnum.Smart_Monthly]: {
        subscriptionPrice: 24.99,
        subscriptionCurrency: 'RON',
        subscriptionUniqueName: 'smart_subscription_monthly',
    },
    [SubscriptionPriceEnum.Scale_Monthly]: {
        subscriptionPrice: 34.99,
        subscriptionCurrency: 'RON',
        subscriptionUniqueName: 'scale_subscription_monthly',
    },
    [SubscriptionPriceEnum.Start_Yearly]: {
        subscriptionPrice: 149.9,
        subscriptionCurrency: 'RON',
        subscriptionUniqueName: 'start_subscription_yearly',
    },
    [SubscriptionPriceEnum.Smart_Yearly]: {
        subscriptionPrice: 249.9,
        subscriptionCurrency: 'RON',
        subscriptionUniqueName: 'smart_subscription_yearly',
    },
    [SubscriptionPriceEnum.Scale_Yearly]: {
        subscriptionPrice: 349.9,
        subscriptionCurrency: 'RON',
        subscriptionUniqueName: 'scale_subscription_yearly',
    }
}; 